/**
 * Aides des champs les moins parlants du formulaire de chambre, et le type des
 * onglets de la modale d'édition.
 *
 * Sortis de `RoomsPage` le 2026-08-30, quand la modale d'édition a suivi le
 * dossier vers `RoomDetailPage` : la création est restée sur la liste, l'édition
 * est partie sur la fiche, et les deux formulaires posent les mêmes questions.
 * Le commentaire d'origine prévenait déjà que deux jeux de libellés finiraient
 * par dire deux choses différentes.
 *
 * `AIDE_PARTAGE` a été retirée au passage : elle était déclarée depuis le début
 * sans qu'aucun écran ne l'affiche — `BathroomSharing` porte sa propre aide.
 */
export const AIDE_NUMERO =
  "Votre repère interne (plan, badge, clé). Jamais affiché sur le site public.";
export const AIDE_TANTIEMES =
  "Quote-part de la chambre dans les parties communes, à rapporter aux « tantièmes " +
  "totaux » de la colocation. Sert pour le calcul de la répartition des charges.";

export type EditTab = 'characteristics' | 'financial' | 'photos';
